module.exports = __webpack_public_path__ + "img/home-title-01.395a9ebf.png";